import { Stack } from "@mui/material";
import { Provider } from "../providerSection";
import { SelectServiceProviderModal } from "./selectServiceProviderModal";
import { SelectedServicesList } from "./selectedServicesList";
import { ServicesAutocomplete } from "./servicesAutocomplete";
import { Service, AvailableService } from "./types";
import { useSelectServiceProviderModal } from "./useSelectServiceProviderModal";

type Props = {
  services: Service[];
  availableServices: AvailableService[];
  selectedProviders: Provider[];
  availableProviders: Provider[];
  disabled: boolean;
  onAddService: (serviceMenuItem: AvailableService) => void;
  onRemoveService: (index: number) => void;
  onReorderServices: (fromIndex: number, toIndex: number) => void;
  onClearServices: () => void;
  onUpdateServiceProvider: (index: number, provider: Provider) => void;
  additionalInfo?: React.ReactNode;
  warningInfo?: React.ReactNode;
};

export const ServicesSection = ({
  services,
  availableServices,
  selectedProviders,
  availableProviders,
  disabled,
  onAddService,
  onRemoveService,
  onReorderServices,
  onClearServices,
  onUpdateServiceProvider,
  additionalInfo,
  warningInfo,
}: Props) => {
  const {
    isModalOpened,
    eligibleProviders,
    selectedProviderId,
    serviceName,
    openSelectProviderModal,
    closeSelectProviderModal,
    updateProviderForService,
    selectProviderId,
  } = useSelectServiceProviderModal({
    availableProviders,
    services,
    onUpdateServiceProvider,
  });

  return (
    <Stack gap={1.5}>
      {additionalInfo}

      <ServicesAutocomplete
        availableServices={availableServices}
        services={services}
        onSelectService={onAddService}
        onClearServices={onClearServices}
        onRemoveService={onRemoveService}
        selectedProviders={
          selectedProviders?.length ? selectedProviders : availableProviders
        }
        disabled={disabled}
      />

      <SelectedServicesList
        services={services}
        onRemoveService={onRemoveService}
        onReorderServices={onReorderServices}
        onEditProvider={openSelectProviderModal}
      />

      {warningInfo}

      <SelectServiceProviderModal
        isOpen={isModalOpened}
        availableProviders={eligibleProviders}
        selectedProviderId={selectedProviderId}
        serviceName={serviceName}
        onClose={closeSelectProviderModal}
        onSubmit={updateProviderForService}
        onSelect={selectProviderId}
      />
    </Stack>
  );
};
